import React from "react"
import { Grid, CircularProgress, makeStyles } from "@material-ui/core"

const useStyle = makeStyles(theme => ({
  root: {
    height: "50vh",
  },
}))

const Loading = () => {
  const classes = useStyle()
  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      className={classes.root}
    >
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  )
}

export default Loading
